import { render, staticRenderFns } from "./AdminProject.vue?vue&type=template&id=b8b0c33a"
import script from "./AdminProject.vue?vue&type=script&lang=js"
export * from "./AdminProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports